import React from 'react'

export const HorizontalSeparator = () => (
  <div className="et-horizontal-separator" />
)
